export const IconFlagEu = ({ rotation = 0 }) => (
  <svg
    width='42'
    height='22'
    viewBox='0 0 42 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_15682_45667)'>
      <path
        d='M0 2.09351C0 0.988939 0.895431 0.0935059 2 0.0935059H39.0877C40.1922 0.0935059 41.0877 0.988936 41.0877 2.09351V19.9065C41.0877 21.011 40.1922 21.9065 39.0877 21.9065H2C0.895431 21.9065 0 21.011 0 19.9065V2.09351Z'
        fill='#3538CD'
      />
      <path
        d='M13.0439 4.09351L12.7439 5.08116L13.2439 5.17993L13.0439 4.09351Z'
        fill='#FDE272'
      />
      <path
        d='M13.044 4.09351L13.344 5.08116L12.844 5.17993L13.044 4.09351Z'
        fill='#FDE272'
      />
      <path
        d='M13.9942 4.77701L12.9509 4.79772L13.0119 5.29952L13.9942 4.77701Z'
        fill='#FDE272'
      />
      <path
        d='M13.9941 4.77658L13.1379 5.36303L12.887 4.92194L13.9941 4.77658Z'
        fill='#FDE272'
      />
      <path
        d='M13.6324 5.88045L13.2858 4.90701L12.8234 5.11646L13.6324 5.88045Z'
        fill='#FDE272'
      />
      <path
        d='M13.6323 5.88066L12.8015 5.25454L13.1462 4.88513L13.6323 5.88066Z'
        fill='#FDE272'
      />
      <path
        d='M12.0934 4.77701L13.1367 4.79772L13.0757 5.29952L12.0934 4.77701Z'
        fill='#FDE272'
      />
      <path
        d='M12.0936 4.77658L12.9497 5.36303L13.2007 4.92194L12.0936 4.77658Z'
        fill='#FDE272'
      />
      <path
        d='M12.4553 5.88045L12.8018 4.90701L13.2642 5.11646L12.4553 5.88045Z'
        fill='#FDE272'
      />
      <path
        d='M12.4554 5.88066L13.2862 5.25454L12.9415 4.88513L12.4554 5.88066Z'
        fill='#FDE272'
      />
      <path
        d='M13.0439 15.9453L12.7439 16.933L13.2439 17.0317L13.0439 15.9453Z'
        fill='#FDE272'
      />
      <path
        d='M13.044 15.9453L13.344 16.933L12.844 17.0317L13.044 15.9453Z'
        fill='#FDE272'
      />
      <path
        d='M13.9942 16.6288L12.9509 16.6495L13.0119 17.1513L13.9942 16.6288Z'
        fill='#FDE272'
      />
      <path
        d='M13.9941 16.6284L13.1379 17.2148L12.887 16.7737L13.9941 16.6284Z'
        fill='#FDE272'
      />
      <path
        d='M13.6324 17.7323L13.2858 16.7588L12.8234 16.9683L13.6324 17.7323Z'
        fill='#FDE272'
      />
      <path
        d='M13.6323 17.7325L12.8015 17.1063L13.1462 16.7369L13.6323 17.7325Z'
        fill='#FDE272'
      />
      <path
        d='M12.0934 16.6288L13.1367 16.6495L13.0757 17.1513L12.0934 16.6288Z'
        fill='#FDE272'
      />
      <path
        d='M12.0936 16.6284L12.9497 17.2148L13.2007 16.7737L12.0936 16.6284Z'
        fill='#FDE272'
      />
      <path
        d='M12.4553 17.7323L12.8018 16.7588L13.2642 16.9683L12.4553 17.7323Z'
        fill='#FDE272'
      />
      <path
        d='M12.4554 17.7325L13.2862 17.1063L12.9415 16.7369L12.4554 17.7325Z'
        fill='#FDE272'
      />
      <path
        d='M7.0439 10.0194L6.7439 11.0071L7.2439 11.1058L7.0439 10.0194Z'
        fill='#FDE272'
      />
      <path
        d='M7.04399 10.0194L7.34399 11.0071L6.84399 11.1058L7.04399 10.0194Z'
        fill='#FDE272'
      />
      <path
        d='M7.99423 10.7029L6.95092 10.7236L7.01194 11.2254L7.99423 10.7029Z'
        fill='#FDE272'
      />
      <path
        d='M7.99405 10.7025L7.13794 11.2889L6.88698 10.8478L7.99405 10.7025Z'
        fill='#FDE272'
      />
      <path
        d='M7.63239 11.8064L7.28585 10.8329L6.82344 11.0424L7.63239 11.8064Z'
        fill='#FDE272'
      />
      <path
        d='M7.63226 11.8066L6.80147 11.1804L7.14615 10.811L7.63226 11.8066Z'
        fill='#FDE272'
      />
      <path
        d='M6.09342 10.7029L7.13672 10.7236L7.0757 11.2254L6.09342 10.7029Z'
        fill='#FDE272'
      />
      <path
        d='M6.09359 10.7025L6.94971 11.2889L7.20067 10.8478L6.09359 10.7025Z'
        fill='#FDE272'
      />
      <path
        d='M6.45526 11.8064L6.8018 10.8329L7.26421 11.0424L6.45526 11.8064Z'
        fill='#FDE272'
      />
      <path
        d='M6.45538 11.8066L7.28617 11.1804L6.94149 10.811L6.45538 11.8066Z'
        fill='#FDE272'
      />
      <path
        d='M9.52963 6.71918L10.3604 6.09301L10.0158 5.72362L9.52963 6.71918Z'
        fill='#FDE272'
      />
      <path
        d='M9.52921 6.71917L9.87581 5.74572L10.3382 5.95514L9.52921 6.71917Z'
        fill='#FDE272'
      />
      <path
        d='M9.16682 5.61489L10.0241 6.20164L10.2743 5.76133L9.16682 5.61489Z'
        fill='#FDE272'
      />
      <path
        d='M9.16665 5.6152L10.2102 5.63699L10.1501 6.13814L9.16665 5.6152Z'
        fill='#FDE272'
      />
      <path
        d='M10.1186 4.9328L9.81786 5.92013L10.3156 6.0179L10.1186 4.9328Z'
        fill='#FDE272'
      />
      <path
        d='M10.119 4.93279L10.4157 5.91908L9.91772 6.01867L10.119 4.93279Z'
        fill='#FDE272'
      />
      <path
        d='M10.7012 6.7177L9.87156 6.09377L10.2182 5.72264L10.7012 6.7177Z'
        fill='#FDE272'
      />
      <path
        d='M10.7045 6.71843L10.3608 5.74548L9.89668 5.95666L10.7045 6.71843Z'
        fill='#FDE272'
      />
      <path
        d='M11.0688 5.61427L10.2095 6.2015L9.96046 5.76316L11.0688 5.61427Z'
        fill='#FDE272'
      />
      <path
        d='M11.0686 5.61412L10.0247 5.63863L10.0834 6.13814L11.0686 5.61412Z'
        fill='#FDE272'
      />
      <path
        d='M8.48153 8.91619L8.13493 7.94274L7.67256 8.15216L8.48153 8.91619Z'
        fill='#FDE272'
      />
      <path
        d='M8.48136 8.91645L7.65056 8.29027L7.99519 7.92089L8.48136 8.91645Z'
        fill='#FDE272'
      />
      <path
        d='M7.30933 8.91485L8.13894 8.29091L7.79231 7.91979L7.30933 8.91485Z'
        fill='#FDE272'
      />
      <path
        d='M7.30601 8.91558L7.64968 7.94262L8.11382 8.1538L7.30601 8.91558Z'
        fill='#FDE272'
      />
      <path
        d='M6.94168 7.81142L7.80102 8.39864L8.05004 7.9603L6.94168 7.81142Z'
        fill='#FDE272'
      />
      <path
        d='M6.94187 7.81126L7.98583 7.83577L7.92714 8.33529L6.94187 7.81126Z'
        fill='#FDE272'
      />
      <path
        d='M8.84392 7.81192L7.9866 8.39866L7.73641 7.95835L8.84392 7.81192Z'
        fill='#FDE272'
      />
      <path
        d='M8.84409 7.81222L7.80054 7.83401L7.86069 8.33516L8.84409 7.81222Z'
        fill='#FDE272'
      />
      <path
        d='M7.89216 7.12982L8.19288 8.11716L7.69514 8.21492L7.89216 7.12982Z'
        fill='#FDE272'
      />
      <path
        d='M7.89171 7.12982L7.595 8.1161L8.09302 8.21569L7.89171 7.12982Z'
        fill='#FDE272'
      />
      <path
        d='M8.84425 13.7532L7.80103 13.7728L7.86279 14.2751L8.84425 13.7532Z'
        fill='#FDE272'
      />
      <path
        d='M8.84378 13.7527L7.98859 14.339L7.73707 13.8971L8.84378 13.7527Z'
        fill='#FDE272'
      />
      <path
        d='M8.48363 14.8568L8.13407 13.8832L7.67339 14.0914L8.48363 14.8568Z'
        fill='#FDE272'
      />
      <path
        d='M8.48314 14.8572L7.65175 14.2295L7.9943 13.8611L8.48314 14.8572Z'
        fill='#FDE272'
      />
      <path
        d='M7.30708 14.8555L8.13693 14.2319L7.78894 13.861L7.30708 14.8555Z'
        fill='#FDE272'
      />
      <path
        d='M7.30767 14.8557L7.64962 13.8828L8.11479 14.0942L7.30767 14.8557Z'
        fill='#FDE272'
      />
      <path
        d='M7.89235 13.07L8.19422 14.057L7.69995 14.154L7.89235 13.07Z'
        fill='#FDE272'
      />
      <path
        d='M7.89049 13.0702L7.59931 14.0556L8.09399 14.1558L7.89049 13.0702Z'
        fill='#FDE272'
      />
      <path
        d='M6.94234 13.7516L7.98655 13.7754L7.92872 14.2754L6.94234 13.7516Z'
        fill='#FDE272'
      />
      <path
        d='M6.94218 13.7517L7.80271 14.3387L8.05101 13.8998L6.94218 13.7517Z'
        fill='#FDE272'
      />
      <path
        d='M11.0147 15.7412L9.97144 15.7607L10.0332 16.2631L11.0147 15.7412Z'
        fill='#FDE272'
      />
      <path
        d='M11.0142 15.7406L10.159 16.3269L9.90748 15.885L11.0142 15.7406Z'
        fill='#FDE272'
      />
      <path
        d='M10.654 16.8448L10.3045 15.8711L9.8438 16.0794L10.654 16.8448Z'
        fill='#FDE272'
      />
      <path
        d='M10.6536 16.8452L9.82216 16.2175L10.1647 15.849L10.6536 16.8452Z'
        fill='#FDE272'
      />
      <path
        d='M9.47749 16.8434L10.3073 16.2199L9.95935 15.8489L9.47749 16.8434Z'
        fill='#FDE272'
      />
      <path
        d='M9.47808 16.8436L9.82003 15.8707L10.2852 16.0821L9.47808 16.8436Z'
        fill='#FDE272'
      />
      <path
        d='M10.0628 15.0579L10.3646 16.0449L9.87036 16.1419L10.0628 15.0579Z'
        fill='#FDE272'
      />
      <path
        d='M10.0609 15.0581L9.76972 16.0436L10.2644 16.1437L10.0609 15.0581Z'
        fill='#FDE272'
      />
      <path
        d='M9.11275 15.7395L10.157 15.7633L10.0991 16.2633L9.11275 15.7395Z'
        fill='#FDE272'
      />
      <path
        d='M9.11259 15.7396L9.97312 16.3266L10.2214 15.8877L9.11259 15.7396Z'
        fill='#FDE272'
      />
      <path
        d='M19.0438 10.0194L19.3438 11.0071L18.8438 11.1058L19.0438 10.0194Z'
        fill='#FDE272'
      />
      <path
        d='M19.0437 10.0194L18.7437 11.0071L19.2437 11.1058L19.0437 10.0194Z'
        fill='#FDE272'
      />
      <path
        d='M18.0934 10.7029L19.1367 10.7236L19.0757 11.2254L18.0934 10.7029Z'
        fill='#FDE272'
      />
      <path
        d='M18.0936 10.7025L18.9497 11.2889L19.2007 10.8478L18.0936 10.7025Z'
        fill='#FDE272'
      />
      <path
        d='M18.4553 11.8064L18.8018 10.8329L19.2642 11.0424L18.4553 11.8064Z'
        fill='#FDE272'
      />
      <path
        d='M18.4554 11.8066L19.2862 11.1804L18.9415 10.811L18.4554 11.8066Z'
        fill='#FDE272'
      />
      <path
        d='M19.9942 10.7029L18.9509 10.7236L19.0119 11.2254L19.9942 10.7029Z'
        fill='#FDE272'
      />
      <path
        d='M19.9941 10.7025L19.1379 11.2889L18.887 10.8478L19.9941 10.7025Z'
        fill='#FDE272'
      />
      <path
        d='M19.6324 11.8064L19.2858 10.8329L18.8234 11.0424L19.6324 11.8064Z'
        fill='#FDE272'
      />
      <path
        d='M19.6323 11.8066L18.8015 11.1804L19.1462 10.811L19.6323 11.8066Z'
        fill='#FDE272'
      />
      <path
        d='M16.558 6.71918L15.7272 6.09301L16.0718 5.72362L16.558 6.71918Z'
        fill='#FDE272'
      />
      <path
        d='M16.5584 6.71917L16.2118 5.74572L15.7495 5.95514L16.5584 6.71917Z'
        fill='#FDE272'
      />
      <path
        d='M16.9208 5.61489L16.0635 6.20164L15.8133 5.76133L16.9208 5.61489Z'
        fill='#FDE272'
      />
      <path
        d='M16.921 5.6152L15.8774 5.63699L15.9376 6.13814L16.921 5.6152Z'
        fill='#FDE272'
      />
      <path
        d='M15.9691 4.9328L16.2698 5.92013L15.772 6.0179L15.9691 4.9328Z'
        fill='#FDE272'
      />
      <path
        d='M15.9686 4.93279L15.6719 5.91908L16.1699 6.01867L15.9686 4.93279Z'
        fill='#FDE272'
      />
      <path
        d='M15.3865 6.7177L16.2161 6.09377L15.8695 5.72264L15.3865 6.7177Z'
        fill='#FDE272'
      />
      <path
        d='M15.3832 6.71843L15.7268 5.74548L16.191 5.95666L15.3832 6.71843Z'
        fill='#FDE272'
      />
      <path
        d='M15.0188 5.61427L15.8782 6.2015L16.1272 5.76316L15.0188 5.61427Z'
        fill='#FDE272'
      />
      <path
        d='M15.019 5.61412L16.063 5.63863L16.0043 6.13814L15.019 5.61412Z'
        fill='#FDE272'
      />
      <path
        d='M17.6061 8.91619L17.9527 7.94274L18.4151 8.15216L17.6061 8.91619Z'
        fill='#FDE272'
      />
      <path
        d='M17.6063 8.91645L18.4371 8.29027L18.0925 7.92089L17.6063 8.91645Z'
        fill='#FDE272'
      />
      <path
        d='M18.7783 8.91485L17.9487 8.29091L18.2953 7.91979L18.7783 8.91485Z'
        fill='#FDE272'
      />
      <path
        d='M18.7816 8.91558L18.438 7.94262L17.9738 8.1538L18.7816 8.91558Z'
        fill='#FDE272'
      />
      <path
        d='M19.146 7.81142L18.2866 8.39864L18.0376 7.9603L19.146 7.81142Z'
        fill='#FDE272'
      />
      <path
        d='M19.1458 7.81126L18.1018 7.83577L18.1605 8.33529L19.1458 7.81126Z'
        fill='#FDE272'
      />
      <path
        d='M17.2437 7.81192L18.101 8.39866L18.3512 7.95835L17.2437 7.81192Z'
        fill='#FDE272'
      />
      <path
        d='M17.2436 7.81222L18.2871 7.83401L18.227 8.33516L17.2436 7.81222Z'
        fill='#FDE272'
      />
      <path
        d='M18.1955 7.12982L17.8948 8.11716L18.3925 8.21492L18.1955 7.12982Z'
        fill='#FDE272'
      />
      <path
        d='M18.1959 7.12982L18.4926 8.1161L17.9946 8.21569L18.1959 7.12982Z'
        fill='#FDE272'
      />
      <path
        d='M17.2434 13.7532L18.2866 13.7728L18.2249 14.2751L17.2434 13.7532Z'
        fill='#FDE272'
      />
      <path
        d='M17.2439 13.7527L18.0991 14.339L18.3506 13.8971L17.2439 13.7527Z'
        fill='#FDE272'
      />
      <path
        d='M17.604 14.8568L17.9536 13.8832L18.4143 14.0914L17.604 14.8568Z'
        fill='#FDE272'
      />
      <path
        d='M17.6045 14.8572L18.4359 14.2295L18.0933 13.8611L17.6045 14.8572Z'
        fill='#FDE272'
      />
      <path
        d='M18.7806 14.8555L17.9507 14.2319L18.2987 13.861L18.7806 14.8555Z'
        fill='#FDE272'
      />
      <path
        d='M18.78 14.8557L18.438 13.8828L17.9729 14.0942L18.78 14.8557Z'
        fill='#FDE272'
      />
      <path
        d='M18.1953 13.07L17.8934 14.057L18.3877 14.154L18.1953 13.07Z'
        fill='#FDE272'
      />
      <path
        d='M18.1972 13.0702L18.4883 14.0556L17.9937 14.1558L18.1972 13.0702Z'
        fill='#FDE272'
      />
      <path
        d='M19.1453 13.7516L18.1011 13.7754L18.1589 14.2754L19.1453 13.7516Z'
        fill='#FDE272'
      />
      <path
        d='M19.1455 13.7517L18.2849 14.3387L18.0366 13.8998L19.1455 13.7517Z'
        fill='#FDE272'
      />
      <path
        d='M15.073 15.7412L16.1162 15.7607L16.0544 16.2631L15.073 15.7412Z'
        fill='#FDE272'
      />
      <path
        d='M15.0735 15.7406L15.9286 16.3269L16.1802 15.885L15.0735 15.7406Z'
        fill='#FDE272'
      />
      <path
        d='M15.4336 16.8448L15.7832 15.8711L16.2439 16.0794L15.4336 16.8448Z'
        fill='#FDE272'
      />
      <path
        d='M15.4341 16.8452L16.2655 16.2175L15.9229 15.849L15.4341 16.8452Z'
        fill='#FDE272'
      />
      <path
        d='M16.6102 16.8434L15.7803 16.2199L16.1283 15.8489L16.6102 16.8434Z'
        fill='#FDE272'
      />
      <path
        d='M16.6096 16.8436L16.2676 15.8707L15.8024 16.0821L16.6096 16.8436Z'
        fill='#FDE272'
      />
      <path
        d='M16.0249 15.0579L15.723 16.0449L16.2173 16.1419L16.0249 15.0579Z'
        fill='#FDE272'
      />
      <path
        d='M16.0268 15.0581L16.3179 16.0436L15.8232 16.1437L16.0268 15.0581Z'
        fill='#FDE272'
      />
      <path
        d='M16.9749 15.7395L15.9307 15.7633L15.9885 16.2633L16.9749 15.7395Z'
        fill='#FDE272'
      />
      <path
        d='M16.9751 15.7396L16.1145 16.3266L15.8662 15.8877L16.9751 15.7396Z'
        fill='#FDE272'
      />
      <path
        d='M24.8376 14.5V7.5H25.8376V13.71H29.0476V14.5H24.8376ZM30.745 14.5V8.32H28.665V7.5H33.815V8.32H31.745V14.5H30.745Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_15682_45667'>
        <rect
          width='41.0877'
          height='21.813'
          fill='white'
          transform='translate(0 0.0935059)'
        />
      </clipPath>
    </defs>
  </svg>
);
